import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { Logo } from "@/components/brand";

export default function SiteFooter() {
  return (
    <footer className="border-t border-slate-100 bg-slate-50/60" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
          <div>
            <Logo size="lg" />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-500">
              Your complete AI employee for business. Handle calls, WhatsApp, email, orders and
              social media from one simple platform.
            </p>
            <p className="mt-5 inline-flex items-center gap-2 rounded-full border border-orange-200 bg-orange-50 px-3.5 py-1.5 text-xs font-semibold text-orange-800" data-testid="footer-talkid-line">
              <Phone className="h-3.5 w-3.5" />
              AI Calling powered by TalkID
            </p>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold text-slate-900">Product</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-600">
              <li><Link to="/#features" data-testid="footer-product-link" className="hover:text-orange-700">Product</Link></li>
              <li><Link to="/pricing" data-testid="footer-pricing-link" className="hover:text-orange-700">Pricing</Link></li>
              <li><Link to="/#contact" data-testid="footer-contact-link" className="hover:text-orange-700">Contact</Link></li>
              <li><Link to="/login" data-testid="footer-login-link" className="hover:text-orange-700">Login</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold text-slate-900">Legal</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-600">
              <li><span data-testid="footer-privacy-link" className="cursor-pointer hover:text-orange-700">Privacy Policy</span></li>
              <li><span data-testid="footer-terms-link" className="cursor-pointer hover:text-orange-700">Terms and Conditions</span></li>
              <li><span data-testid="footer-refund-link" className="cursor-pointer hover:text-orange-700">Refund and Cancellation Policy</span></li>
              <li><span data-testid="footer-acceptable-use-link" className="cursor-pointer hover:text-orange-700">Acceptable Use Policy</span></li>
              <li><span data-testid="footer-data-ai-link" className="cursor-pointer hover:text-orange-700">Data and AI Policy</span></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold text-slate-900">Contact</h4>
            <ul className="mt-4 space-y-3 text-sm text-slate-600">
              <li className="flex items-center gap-2.5"><Mail className="h-4 w-4 text-orange-600" /> hello@creativesolution.online</li>
              <li className="flex items-center gap-2.5"><Phone className="h-4 w-4 text-orange-600" /> +91 98XXX XXXXX</li>
              <li className="flex items-start gap-2.5"><MapPin className="mt-0.5 h-4 w-4 text-orange-600" /> Serving businesses across India</li>
            </ul>
          </div>
        </div>
        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-slate-200 pt-6 text-xs text-slate-500 sm:flex-row">
          <p>© 2026 Creative Solution AI. All rights reserved.</p>
          <p>Made for Indian small businesses.</p>
        </div>
      </div>
    </footer>
  );
}
